import {Button, Header} from 'semantic-ui-react';
import React from 'react';

import DefaultForm from '@appComponents/DefaultForm';
import {convertMinutesWithOneDecimalToSeconds, getMinutesAndSeconds} from '@utils/helpers';
import {UpdateDuration} from '@graphql/reports/mutation';
import {hideModal, showModalConfirmation} from '@utils/modal';
import { DELETED, NOT_DELETED } from '@constants/messages';
import {refetchQueryByName} from '@utils/apollo';
import {showMessageBox} from '@utils/messageBox';

import apolloClient from '../../../apolloClient';

export default class SetDurationForm extends DefaultForm {
    componentDidMount() {
        super.componentDidMount();

        this.setCreateErrorCallback(() => {
            hideModal();
        });

        this.setUpdateErrorCallback(() => {
            hideModal();
        });

        this.setDeleteSuccessCallback(() => {
            hideModal();
        });
        this.setState(() => ({
            defaultForm_formTitle: this.props.formParams.duration
                ? 'Modify the duration of the event'
                : 'Set a duration for the event',
        }));
        this.setField('info_message', {matchData: this.props.formParams.optionsVariables.matchData});

        this.props.formParams.duration && this.handleDurationChange(this.props.formParams.duration);
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (this.props.formValues.duration && prevProps.formValues?.duration !== this.props.formValues.duration) {
            this.handleDurationChange(this.props.formValues.duration);
        }
    }

    handleDurationChange(duration) {
        const durationData = getMinutesAndSeconds(duration);
        this.setField(
            'duration',
            {description: <div className='--paddingLeft-4-5-rem'>({durationData.minutes} minutes {durationData.seconds} seconds)</div>});

    }

    prepareDataForSubmit(data) {
        return {
            duration: convertMinutesWithOneDecimalToSeconds(data.duration),
            eventId: this.props.formParams.optionsVariables.event,
        };
    }

    renderSaveButton(props = {}) {
        return super.renderSaveButton({
            ...props,
            content: 'Save',
        });
    }

    deleteDurationMutation = () => {
        apolloClient.mutate({
            mutation: UpdateDuration,
            variables: {
                eventId: this.props.formParams.id,
                duration: null,
            },
        }).then(() => {
            hideModal();
            refetchQueryByName('GetDurationAndMatch');
            showMessageBox(
                'durationDeletedMessage',
                DELETED('duration'),
                null,
                'success'
            );
        }).catch((error) => {
            hideModal();
            showMessageBox(
                'durationDeletedMessage',
                NOT_DELETED('duration'),
                `${error}`,
                'error'
            );
        });
    };

    deleteDuration = () => {
        showModalConfirmation({
            header: <Header icon='trash' content='Delete duration'/>,
            onYes: () => this.deleteDurationMutation(),
            text: 'Are you sure you want to delete the duration?',
            onNo: () => {
                hideModal();
            },
        });
    };

    renderDeleteButton = () => {
        if (!this.props.formParams.duration) {
            return null;
        }

        return (
            <Button onClick={this.deleteDuration}
                color='red'
                disabled={this.props.submitting}
                icon='trash'
                content='Delete'
            />
        );
    };
}
